<template>
  <div class="contentBox">
    <div class="contentBlock">
      <img :src="footerImg" />
    </div>
  </div>
</template>

<script>
import "./index.css";
import footerImg from "@/page/cptthanhvancompany/components/img/footer.png";

export default {
  data() {
    return {
      footerImg,
    };
  },
};
</script>
